import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { isNullOrUndefined } from '../_infrastructure/objectUtils';

@Component({
    selector: 'instance-browser-detail',
    templateUrl: './instance-browser-detail.component.html',
    standalone: false
})
export class InstanceBrowserDetailComponent {

  @Input()
  public item: models.InstanceDetailVM;

  constructor(private datePipe: DatePipe) {
  }

  public getDateText(date: Date) {
    if (isNullOrUndefined(date) || date.toString() === "")
      return "N/A";
    else
      return this.datePipe.transform(date, 'yyyy-MM-dd');
  }
}
